import { motion } from "framer-motion";
import StoreButtons from "@/components/site/StoreButtons";
import DiceScene from "@/components/landing/DiceScene";

const TONES = ["text-white", "text-ember", "text-forge"];

export default function Hero({ settings }) {
  const words = (settings?.hero_headline || "ROLL MOVE FORGE").split(" ");

  return (
    <section data-testid="hero-section" className="relative overflow-hidden pt-28 pb-8 md:pt-32 md:pb-10">
      <div
        className="pointer-events-none absolute -top-[380px] left-1/2 -translate-x-1/2 w-[1200px] h-[880px] rounded-full ember-glow"
        style={{ background: "radial-gradient(ellipse at 50% 40%, rgba(255,52,52,.18), rgba(238,101,51,.04) 38%, transparent 70%)" }}
      />

      <div className="relative mx-auto w-[min(1180px,calc(100%-32px))] grid lg:grid-cols-[1fr_0.9fr] gap-10 items-center">
        <div className="text-center lg:text-left">
          <h1 className="headline text-5xl sm:text-6xl lg:text-[70px] mb-6 flex flex-wrap justify-center lg:justify-start gap-x-4">
            {words.map((word, i) => (
              <motion.span
                key={`${word}-${i}`}
                className={`inline-block ${TONES[i % TONES.length]}`}
                initial={{ opacity: 0, y: 34, rotate: 3 }}
                animate={{ opacity: 1, y: 0, rotate: 0 }}
                transition={{ duration: 0.85, delay: 0.12 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              >
                {word}
              </motion.span>
            ))}
          </h1>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.62, duration: 0.7 }}
            className="max-w-[560px] mx-auto lg:mx-0 mb-8"
          >
            <p
              data-testid="hero-tagline"
              className="display text-base md:text-lg tracking-[0.18em] text-white/85 mb-4"
            >
              {settings?.hero_tagline}
            </p>
            <p data-testid="hero-sub" className="text-sm md:text-base text-white/50 leading-[1.85]">
              {settings?.hero_sub}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.78, duration: 0.7 }}
            className="flex justify-center lg:justify-start"
          >
            <StoreButtons settings={settings} testIdPrefix="hero-store" />
          </motion.div>
        </div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 1 }}>
          <DiceScene />
          <p className="display text-[10px] tracking-[0.3em] text-white/25 text-center mt-5">
            {settings?.hero_question}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
